/**
 * Recaptcha
 * 
 * Use Google Recaptcha to check a visitor's score:
 * At first, find the sum field and hide it.
 * If score is below 0.2, show the sum field again.
 */

export function checkRecaptchaScore(form) {
  const sum = form.querySelector('input[name="sum"]')
  if (! sum) return
  const sumWrapper = sum.closest('.c-input')
  const recaptchaScore = form.querySelector('input[name="recaptcha_score"]')
  if (!sumWrapper || !window.grecaptcha) return

  window.grecaptcha.ready(function() {
    hideSum(sum, sumWrapper)

    window.grecaptcha.execute('6Ldw74cUAAAAAMsc9mjQZIhsed3lPhrNz7L5hpK6', {action: 'form_submission'})
    .then(function(token) {
      fetchCaptchaScore(token).then((response) => {
        return response.json()
      }).then((r) => {
        if (r && r.score < 0.2) {
          showSum(sum, sumWrapper)
        }
        if (recaptchaScore) {
          recaptchaScore.value = r.score
        }
      }).catch((e) => {
        console.log(e)
        showSum(sum, sumWrapper)
      })
    }) // end .then
  })

}

const fetchCaptchaScore = (token) => {
  const formData = new window.FormData()
  formData.append('token', token)
  return window.fetch('/wordpress/wp-admin/admin-ajax.php?action=verify_recaptcha', {
    credentials: 'same-origin',
    method: 'post',
    body: formData
  })
}

const hideSum = (sum, sumWrapper) => {
  sum.disabled = true
  sum.classList.add('disabled')
  sumWrapper.classList.add('hidden')
}

const showSum = (sum, sumWrapper) => {
  sum.disabled = false
  sum.classList.remove('disabled')
  sumWrapper.classList.remove('hidden')
}


// WEBPACK FOOTER //
// ./src/js/modules/Recaptcha.js